"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPathForLocale = void 0;
var getPathForLocale = (locale, path) => "/".concat(locale, "/").concat(path);
exports.getPathForLocale = getPathForLocale;